import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class ReparationVehicleClaim extends BaseModel {
    @Expose() reparationId = 0;
    @Expose() promiseDeliveryCdrDate = "";
    @Expose() startReparationDate = "";
    @Expose() finishedUnitDate = "";
    @Expose() advanceRepair = 0;
    @Expose() budgetStatusKey = "";
}
